
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { PalantirSkeletonComponent } from '@fieldcontrol/palantir'

@Component({
    selector: 'app-detail-item',
    templateUrl: './detail-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    PalantirSkeletonComponent
]
})
export class DetailItemComponent {
  @Input({ required: true })
  public title!: string

  @Input({ required: true })
  public value?: string | null = ''

  @Input({ required: true })
  public isLoading?: boolean
}
